/* global window */

import { call, put, takeLatest, all } from 'redux-saga/effects';

import { setAddressFormat } from 'redux/addressFormats/sagas';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getForWeb } from './api';
import {
  GET_SETTING_SUCCESS,
  GET_SETTING_OBJECT_REQUESTING,
  GET_SETTING_REQUEST
} from './constants';

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_SETTING_OBJECT_REQUESTING });
    const response = yield call(getForWeb);

    // Temp adding router settings here. We initially pulled route settings from the window, but moved it to the API.
    // todo - This should be refactored to pull from redux settings throughout the app
    window.commerce7 = {
      router: response.data.routerType,
      routes: {
        cart: response.data.baseRoute.cart,
        checkout: response.data.baseRoute.checkout,
        club: response.data.baseRoute.club,
        collection: response.data.baseRoute.collection,
        product: response.data.baseRoute.product,
        profile: response.data.baseRoute.profile,
        reservation: response.data.baseRoute.reservation
      }
    };

    yield put({ type: GET_SETTING_SUCCESS, payload: response.data });
    yield call(setAddressFormat, {
      addressFormat: response.data.defaultAddressFormat
    });
  } catch (error) {
    if (error.response?.data.key === 'invalidGateway') {
      action.onError();
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* watchList() {
  yield takeLatest(GET_SETTING_REQUEST, get);
}

export default function* settingSagas() {
  yield all([watchList()]);
}
